import { useQueryClient } from "@tanstack/react-query";
import { useEffect, useRef } from "react";

import { type PreviewFile, prefetchFilePreview } from "./file-preview-dialog";

/** A pointer resting this long on a file means it is about to be opened; passing over it does not. */
const INTENT_DELAY_MS = 120;

/**
 * Props for anything that opens a file's preview: resting on it (or focusing it) starts loading the document,
 * so the preview opens on a document already on its way.
 */
export function usePreviewPrefetch() {
  const queryClient = useQueryClient();
  const timer = useRef<number | undefined>(undefined);
  useEffect(() => () => window.clearTimeout(timer.current), []);

  return (file: PreviewFile) => ({
    onPointerEnter: () => {
      window.clearTimeout(timer.current);
      timer.current = window.setTimeout(() => prefetchFilePreview(queryClient, file), INTENT_DELAY_MS);
    },
    onPointerLeave: () => window.clearTimeout(timer.current),
    onFocus: () => prefetchFilePreview(queryClient, file),
  });
}
